var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _circle2, _path16, _path17, _linearGradient, _path18, _linearGradient2, _path19;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDelivery(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    id: "delivery-truck",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 421.63,
    cy: 377.48,
    r: 20.53,
    fill: "#ECEFF0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#526471",
    d: "M22.15 351.02h43.67c-4.78 7.68-7.54 16.75-7.54 26.46H22.15v-26.46z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ECEFF0",
    d: "M108.47 356.95c11.34 0 20.54 9.19 20.54 20.53s-9.2 20.53-20.54 20.53c-11.33 0-20.53-9.19-20.53-20.53s9.2-20.53 20.53-20.53z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#303C44",
    d: "M151.13 351.02c4.78 7.68 7.54 16.75 7.54 26.46 0 27.72-22.48 50.19-50.2 50.19s-50.19-22.47-50.19-50.19c0-9.71 2.76-18.78 7.54-26.46 8.85-14.25 24.64-23.73 42.65-23.73s33.81 9.48 42.66 23.73zm-22.12 26.46c0-11.34-9.2-20.53-20.54-20.53-11.33 0-20.53 9.19-20.53 20.53s9.2 20.53 20.53 20.53c11.34 0 20.54-9.19 20.54-20.53z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#526471",
    d: "M378.97 351.02h.01c-4.78 7.68-7.54 16.75-7.54 26.46H158.67c0-9.71-2.76-18.78-7.54-26.46h227.84z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#303C44",
    d: "M464.28 351.02c4.78 7.68 7.54 16.75 7.54 26.46 0 27.72-22.47 50.19-50.19 50.19s-50.19-22.47-50.19-50.19c0-9.71 2.76-18.78 7.54-26.46 8.85-14.25 24.64-23.73 42.65-23.73 18.01 0 33.8 9.48 42.65 23.73zm-22.12 26.46c0-11.34-9.19-20.53-20.53-20.53s-20.53 9.19-20.53 20.53 9.19 20.53 20.53 20.53 20.53-9.19 20.53-20.53z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#526471",
    d: "M489.85 351.02v26.46h-18.03c0-9.71-2.76-18.78-7.54-26.46h25.57z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#007ECA",
    d: "M434.33 139.36c-18.44-9.7-42.99-16.26-75.66-16.26v96.74h131.17s-3.12-52.92-55.51-80.48z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M489.84 219.84h-1.81c-3.93-17-16.18-49.74-53.7-69.48-18.44-9.7-42.99-16.26-75.66-16.26v-11c32.67 0 57.22 6.56 75.66 16.26 52.39 27.56 55.51 80.48 55.51 80.48z",
    opacity: 0.2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#ECEFF0",
    d: "M358.67 84.33v266.69H151.13c-8.85-14.25-24.65-23.73-42.66-23.73-18.01 0-33.8 9.48-42.65 23.73H22.15V84.33h336.52z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFC035",
    d: "M489.85 219.84v131.18h-25.57c-8.85-14.25-24.64-23.73-42.65-23.73s-33.8 9.48-42.65 23.73h-20.31V219.84h131.18z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M489.85 351.02V219.84H358.67M22.15 351.02V84.33h336.52v266.69"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M489.84 219.84s-3.12-52.92-55.51-80.48c-18.44-9.7-42.99-16.26-75.66-16.26h-.01"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#ECEFF0",
    d: "M413.76 256H384.1a4 4 0 0 1 0-8h29.66a4 4 0 0 1 0 8z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M371.43 377.48H158.67M151.13 351.02h227.84M471.83 377.48h18.02v-26.46h-25.57M65.82 351.02H22.15v26.46h36.13"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M65.82 351.02c8.85-14.25 24.64-23.73 42.65-23.73s33.81 9.48 42.66 23.73c4.78 7.68 7.54 16.75 7.54 26.46 0 27.72-22.48 50.19-50.2 50.19s-50.19-22.47-50.19-50.19c0-9.71 2.76-18.78 7.54-26.46zM378.98 351.02c8.85-14.25 24.64-23.73 42.65-23.73 18.01 0 33.8 9.48 42.65 23.73 4.78 7.68 7.54 16.75 7.54 26.46 0 27.72-22.47 50.19-50.19 50.19s-50.19-22.47-50.19-50.19c0-9.71 2.76-18.78 7.54-26.46z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 421.63,
    cy: 377.48,
    r: 20.53,
    fill: "none"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M108.47 356.95c11.34 0 20.54 9.19 20.54 20.53s-9.2 20.53-20.54 20.53c-11.33 0-20.53-9.19-20.53-20.53s9.2-20.53 20.53-20.53z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#303C44",
    d: "M358.67 219.84h131.17v8.66H358.67zM22.15 84.33h336.51v16.837H22.15z",
    opacity: 0.2
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 160.205,
    x2: 331.65,
    y1: 206.595,
    y2: 378.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF",
    stopOpacity: 0
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M358.67 122.58v228.44H151.13c-8.85-14.25-24.65-23.73-42.66-23.73-18.01 0-33.8 9.48-42.65 23.73H22.15v-6.37l336.52-222.07z",
    opacity: 0.1
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 425.25,
    x2: 488.52,
    y1: 289.08,
    y2: 352.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF",
    stopOpacity: 0
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M489.85 229.8v121.22h-25.57c-8.85-14.25-24.64-23.73-42.65-23.73s-33.8 9.48-42.65 23.73h-15.67L489.85 229.8z",
    opacity: 0.1
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelivery);
export default __webpack_public_path__ + "static/media/delivery.74a2ee62c5b7e75941f8c0992b98a068.svg";
export { ForwardRef as ReactComponent };